import React from 'react';
import { LoadingBox, Loaddata, LeftLoading, Left, Right, Top, Bottom, RightLoading, Main } from './styles';

export default function ChatLoading() {
  return (
    <Main>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
      <LoadingBox>
        <Loaddata>
          <LeftLoading>
            <Left className='loading-animation'></Left>
            <Right>
              <Top className='loading-animation'></Top>
              <Bottom className='loading-animation'></Bottom>
            </Right>
          </LeftLoading>
          <RightLoading className='loading-animation' />
        </Loaddata>
      </LoadingBox>
    </Main>
  );
}
